import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { ChatwootWidget } from '@/components/chatwoot-widget';
import { HeaderPageSkeleton } from '@/components/skeletons/header-page-skeleton';
import { useSettingsSearchStore } from '@/stores/settings-search-store';
import { Header } from '../header';

/**
 * `/settings` 配下から外れた際に設定検索キーワードをリセットする。
 * useLocation による再レンダリングを HeaderLayout 本体に波及させないため独立コンポーネントにしている。
 */
const SettingsSearchResetter = () => {
  const { pathname } = useLocation();
  const reset = useSettingsSearchStore((state) => state.reset);

  useEffect(() => {
    if (pathname !== '/settings' && !pathname.startsWith('/settings/')) {
      reset();
    }
  }, [pathname, reset]);

  return null;
};

export const HeaderLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SettingsSearchResetter />
      <Header />
      <div className="flex-1">
        <main className="md:px-10 px-5 overflow-x-clip">
          <Suspense fallback={<HeaderPageSkeleton />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <ChatwootWidget />
    </div>
  );
};
